<template>
  <div class="flex items-center gap-8">
    <span class="body-2">{{ i18n(translations.text) }}</span>
    <PaymentIcons :methods="filteredMethods" />
    <RevTooltip>
      <template #trigger="{ show, hide }">
        <RevButtonIcon
          :aria-label="i18n(translations.tooltipIconAriaLabel)"
          :icon="IconInfo"
          size="small"
          variant="ghost"
          @click="!isHoverMedia && show()"
          @focusin="show"
          @focusout="hide"
          @mouseenter="show"
          @mouseleave="hide"
        />
      </template>
      <span class="body-2">{{ i18n(translations.tooltipContent) }}</span>
    </RevTooltip>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import {
  type PaymentMethod,
  PaymentMethodCode,
} from '@backmarket/http-api/src/api-specs-payment/payment/payment.types'
import PaymentIcons from '@backmarket/nuxt-layer-payment/methods/PaymentIcons'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButtonIcon } from '@ds/components/ButtonIcon'
import { RevTooltip } from '@ds/components/Tooltip'
import { IconInfo } from '@ds/icons/IconInfo'
import { useMediaQuery } from '@vueuse/core'

import translations from './USPaymentAdvertisement.translations'

const WHITELISTED_METHODS: PaymentMethodCode[] = [
  PaymentMethodCode.AFFIRM,
  PaymentMethodCode.KLARNA_PAY_LATER,
  PaymentMethodCode.KLARNA_PAY_NOW,
  PaymentMethodCode.KLARNA_SLICE_IT,
  PaymentMethodCode.PAYPAL,
]

const i18n = useI18n()
const isHoverMedia = useMediaQuery('(hover: hover)')

const props = withDefaults(
  defineProps<{
    methods?: PaymentMethod[] | null
  }>(),
  { methods: null },
)

const filteredMethods = computed(() =>
  (props.methods ?? []).filter(({ bmCode }) =>
    WHITELISTED_METHODS.includes(bmCode),
  ),
)
</script>
